import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { CapacitorHttpService } from './capacitor/capacitor-http.service';

@Injectable()
export class ClientDetailsApiInterceptor implements HttpInterceptor {
  constructor(private capacitorHttpService: CapacitorHttpService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.capacitorHttpService.getDeviceHeader()).pipe(
      switchMap((deviceHeaders) => {
        const authReq = req.clone({
          headers: req.headers.set('X-Client-Details', deviceHeaders['X-Client-Details']),
        });
        return next.handle(authReq);
      }),
    );
  }
}
